"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 5.7A1.7 1.7 0 0 1 4.7 4h14.6A1.7 1.7 0 0 1 21 5.7v11.45a1.7 1.7 0 0 1-1.7 1.7h-7.104l-5.02 3.048a.7.7 0 0 1-1.064-.598v-2.45H4.7a1.7 1.7 0 0 1-1.7-1.7V5.7Zm1.7-.3a.3.3 0 0 0-.3.3v11.45a.3.3 0 0 0 .3.3h2.112a.7.7 0 0 1 .7.7v1.906l4.125-2.504A.7.7 0 0 1 12 17.45h7.3a.3.3 0 0 0 .3-.3V5.7a.3.3 0 0 0-.3-.3H4.7Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.842 10.738v3.129h.66v-3.129h-.66Zm1.354.101c.213.013.456-.052.704-.277v-.03.002c0 .005-.3.295-.704.305Zm-.456-.325h.461l-.46-.008v.008Zm.467-.326c.387.023.672.3.693.326h.001v-.027c-.24-.232-.481-.305-.694-.299Zm.694.33a1.168 1.168 0 0 0-1.15-1.18H8.602c-.64 0-1.16.52-1.16 1.16v3.608c0 .641.52 1.16 1.16 1.16h1.134a1.155 1.155 0 0 0 1.165-1.13v-3.618Zm-1.168-.012v.008h-.23l-.002-.002v-.009l.232.003Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m12.318 8.896-1.52 2.483a.7.7 0 1 1-1.195-.731l1.523-2.485a1.812 1.812 0 0 1 3.354.94v.62h.544c.608 0 1.176.305 1.512.812a1.83 1.83 0 0 1 .235 1.517l-.602 2.11a1.53 1.53 0 0 1-1.47 1.109H11.75c-.403 0-.794-.141-1.105-.398l-.001-.001-.891-.741a.7.7 0 0 1 .895-1.077l.89.74c.06.05.135.077.212.077h2.948a.13.13 0 0 0 .125-.094l.602-2.11a.432.432 0 0 0-.055-.357l-.001-.001a.415.415 0 0 0-.346-.186H13.78a.7.7 0 0 1-.7-.7V9.108a.411.411 0 0 0-.762-.212Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FeedbackIcon24.js.map